export const COOKIES_NOTIFY_ID = 'cookies-notify';
